import axios from "axios";
import { ordersServicesPath} from "../../../Constants";

const coefficientExchangeRateRestUrl = ordersServicesPath + '/organizations/coefficient-exchange-rates'

export default class CoefficientExchangeRateService {

    static async getAllBySupplierId(supplierId) {
        return axios.get(coefficientExchangeRateRestUrl + '/by-supplierId?supplierId=' + supplierId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}